import { UbisoftOverlayService } from 'modules/ubisoft-overlay-service/service';
import {
    LOAD_UBISOFT_OVERLAY_DONE,
    LOAD_UBISOFT_OVERLAY_ERROR
} from './ubisoft-connect-overlay-provider.constants';
import { Dispatch } from 'types/dispatch';

export const loadUbisoftConnectOverlay = () => (dispatch: Dispatch, getState: Function) => {
    const {
        config: { envName },
    } = getState();

    return UbisoftOverlayService.loadSDKScript(envName)
        .then(() => {
            dispatch({
                type: LOAD_UBISOFT_OVERLAY_DONE
            });
        })
        .catch(() => {
            dispatch({
                type: LOAD_UBISOFT_OVERLAY_ERROR
            });
        });
};
